<template>
  <section id="features" class="relative z-10 py-32">
    <div class="container mx-auto px-6">
      <div class="text-center mb-20 reveal-on-scroll">
        <span class="text-[10px] tracking-[0.4em] text-indigo-400 uppercase font-medium">Core Features</span>
        <h2 class="text-3xl md:text-5xl font-bold tracking-tight text-white mt-4">
          {{ displayedContent.featuresTitle }}
        </h2>
        <div class="h-px w-16 bg-indigo-500/50 mx-auto mt-6"></div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div
          v-for="(feature, index) in features"
          :key="index"
          class="reveal-on-scroll group relative h-[480px] overflow-hidden rounded-3xl border border-white/5 bg-slate-900 transition-all duration-700 cursor-pointer"
          :style="{ transitionDelay: index * 0.1 + 's' }"
          @mouseenter="hoveredIndex = index"
          @mouseleave="hoveredIndex = null"
        >
          <!-- 背景图片 -->
          <div
            class="absolute inset-0 transition-all duration-700 ease-out"
            :style="{
              backgroundImage: `url(${feature.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              transform: hoveredIndex === index ? 'scale(1.1)' : 'scale(1)',
              filter: hoveredIndex === index ? 'brightness(1.2)' : 'brightness(0.6)'
            }"
          ></div>

          <!-- 渐变遮罩 -->
          <div
            class="absolute inset-0 transition-opacity duration-500"
            :class="hoveredIndex === index
              ? 'bg-gradient-to-t from-black/90 via-black/50 to-transparent'
              : 'bg-gradient-to-t from-black/80 via-black/30 to-black/40'"
          ></div>

          <!-- 内容区域 -->
          <div class="absolute bottom-0 left-0 right-0 p-8 z-10">
            <!-- 图标/编号 -->
            <div class="flex items-center space-x-3 mb-4">
              <div
                class="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-sm font-bold text-indigo-400 transition-all duration-500"
                :class="hoveredIndex === index ? 'bg-indigo-500/20 border-indigo-400/50' : 'bg-white/5'"
              >
                {{ String(index + 1).padStart(2, '0') }}
              </div>
              <div class="h-px flex-1 bg-gradient-to-r from-white/20 to-transparent"></div>
            </div>

            <h3
              class="text-2xl font-bold text-white tracking-tight mb-3 transition-all duration-500"
              :class="hoveredIndex === index ? 'translate-y-0' : ''"
            >
              {{ displayedContent[feature.key + 'Title'] }}
            </h3>

            <!-- 悬停时展开的描述 -->
            <div
              class="overflow-hidden transition-all duration-500 ease-out"
              :style="{
                maxHeight: hoveredIndex === index ? '200px' : '0px',
                opacity: hoveredIndex === index ? 1 : 0
              }"
            >
              <p class="text-slate-300 text-sm leading-relaxed">
                {{ displayedContent[feature.key + 'Desc'] }}
              </p>
            </div>

          </div>

          <!-- 悬停时的光晕边框 -->
          <div
            class="absolute inset-0 rounded-3xl transition-opacity duration-500 pointer-events-none"
            :class="hoveredIndex === index ? 'opacity-100' : 'opacity-0'"
            :style="{
              boxShadow: 'inset 0 0 30px rgba(99, 102, 241, 0.15), 0 0 30px rgba(99, 102, 241, 0.05)'
            }"
          ></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { translations } from '../const'

const props = defineProps({
  lang: {
    type: String,
    default: 'en'
  }
})

const hoveredIndex = ref(null)

const displayedContent = computed(() => translations[props.lang])

const features = [
  { key: 'feature1', image: `/images/${props.lang}/screenshot1.jpg` },
  { key: 'feature2', image: `/images/${props.lang}/screenshot2.jpg` },
  { key: 'feature3', image: `/images/${props.lang}/screenshot3.jpg` },
  { key: 'feature4', image: `/images/${props.lang}/screenshot4.jpg` },
  { key: 'feature5', image: `/images/${props.lang}/screenshot5.jpg` }
]
</script>